var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fm"},[_c('div',{staticClass:"fs"},[_c('div',{staticClass:"sh"},[_vm._v("\r\n      Sign in to continue\r\n    ")]),_vm._v(" "),_c('div',[_c('span',[_c('button',{staticClass:"btn btn-warning subBtn",on:{"click":_vm.signIn}},[_vm._v("Sign In")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }